import * as types from "../constants/actionTypes";

export const showGlobalModal = payload => ({
  type: types.GLOBAL_MODAL_SHOW,
  payload
});
export const dismissGlobalModal = () => ({ type: types.GLOBAL_MODAL_DISMISS });



// WEBPACK FOOTER //
// ./src/actions/globalModalActions.js